module.exports = __webpack_public_path__ + "img/dots_one.e3f26c58.webp";